import React, { useEffect, useState } from "react";
import "rc-slider/assets/index.css";
import { Input, Row, Col, Label } from "reactstrap";
import SystemLabel from "../../system/SystemLabel/SystemLabel";
import Slider, { createSliderWithTooltip } from "rc-slider";
import "./EditorSlider.css";
const SliderWithTooltip = createSliderWithTooltip(Slider);

const def = {
  label: "Margin",
  value: 22,
  defaultValue: 0,
  units: ["px", "em", "rem"],
  activeUnit: "rem",
  onChange: () => null,
  path: "",
};

/* function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
} */

export const EditorSlider = (props) => {
  const { label, value, defaultValue, units, activeUnit, onChange, path, unitChange, steps, max, min, attachUnit = false, responsiveSettings, dark = false, extraParam = null } = props;

  let uList = units && units.length > 0 ? [...units, "vw"] : units;

  return (
    <div>
      <Row style={{ margin: "0px" }}>
        <Col style={{ padding: 0, paddingLeft: !dark ? 10 : 0 }}>
          <Label className={dark ? "primary-text" : ""}>
            <SystemLabel name={label} />
          </Label>
        </Col>

        <Col
          style={{
            display: "inline-flex",
            padding: 0,
            paddingTop: "4px",
            flexDirection: "row-reverse",
          }}
        >
          {uList
            .sort((a, b) => {
              return a > b;
            })
            .map((u, i) => {
              return (
                <span
                  className={u === activeUnit ? "active" : ""}
                  style={{
                    fontWeight: u === activeUnit ? "bold" : "initial",
                    fontSize: "10px",
                    margin: "0px 5px",
                    textTransform: "uppercase",
                    color: u === activeUnit ? "#17a2b8" : "darkgray",
                    textDecoration: u === activeUnit ? "underline" : "initial",
                    cursor: "pointer",
                  }}
                  onClick={() => unitChange(u, path)}
                  key={i}
                >
                  {u}
                </span>
              );
            })}
        </Col>
      </Row>
      <Row style={{ margin: "0px" }}>
        <Col
          style={{
            maxWidth: "70%",
            padding: "0px",
            paddingLeft: 10,
            paddingRight: "11px",
          }}
        >
          <SliderWithTooltip
            value={value}
            defaultValue={0}
            min={min ? min : 0}
            step={steps ? steps : 1}
            style={{ marginTop: "10px" }}
            max={max ? max : 100}
            /*   trackStyle={{ backgroundColor: "rgb(23, 162, 184)" }}
              handleStyle={{marginTop: '-7px', width: '17px', height: '17px', border: '2px solid #17a2b8;', '&:active': {backgroundColor: '#17a2b8', border: '0px'}}} */
            onChange={(e) => {
              onChange(null, attachUnit ? e + activeUnit : e, path, attachUnit ? activeUnit : null);
            }}
          />
        </Col>
        <Col className={dark ? "dark-input" : ""} style={{ maxWidth: "30%", padding: "0px", paddingLeft: "0px" }}>
          <Input
            autoComplete="jirango-nofill"
            type="number"
            step={steps ? steps : 1}
            min={min ? min : 0}
            max={max ? max : 100}
            value={value >= min ? value : null}
            onChange={(e) => {
              onChange(null, attachUnit ? e.target.value + activeUnit : e.target.value /* + (activeUnit || lastUnit) */, path, attachUnit ? activeUnit : null);
            }}
            //defaultValue={defaultValue}
          />
        </Col>
      </Row>
    </div>
  );
};

export default EditorSlider;
